export enum CardContext {
    Default = 'default',
    Muted = 'muted',
    Danger = 'danger',
}
